import { render, staticRenderFns } from "./multiple_heading_with_content.vue?vue&type=template&id=029dc136&scoped=true&"
import script from "./multiple_heading_with_content.vue?vue&type=script&lang=js&"
export * from "./multiple_heading_with_content.vue?vue&type=script&lang=js&"
import style0 from "./multiple_heading_with_content.vue?vue&type=style&index=0&id=029dc136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029dc136",
  null
  
)

export default component.exports